export type AssignedCourseRolesType = {
  [coursePath: string]:
    | {
        role: 'admin';
      }
    | {
        role: 'staff';
        cohortRoles: {
          [cohortPath: string]: {
            facilitator: boolean;
            assessor: boolean;
            // eslint-disable-next-line camelcase
            assessment_designer: boolean;
          };
        };
      }
    | {
        role: 'user';
        cohortRoles: {
          [cohortPath: string]: boolean;
        };
      };
};

export type CourseRolesPayloadType = (
  | {
      course: string;
      role: 'admin';
    }
  | {
      cohort: string;
      role: 'staff';
      roles: ('facilitator' | 'assessor' | 'assessment_designer')[];
    }
  | {
      cohort: string;
      role: 'user';
    }
)[];

export type MemberType = 'team members' | 'learners';

export enum NavStateEnum {
  VIEW_MEMBER = 'VIEW_MEMBER',
  ADD_MEMBER = 'ADD_MEMBER',
  RECENTLY_ASSIGNED_COURSES = 'RECENTLY_ASSIGNED_COURSES',
  RECENTLY_ADDED_MEMBERS = 'RECENTLY_ADDED_MEMBERS',
}
